export default "/images/e76d00d824284a55108912eb85999b88.avif";